<h2 mat-dialog-title>{{ isExisting ? "Edit" : "Add" }} Request</h2>
<div mat-dialog-content>
  <form class="consent-form">
    <div class="row gutters">
      <deal-search
        class="col-md-6"
        [control]="addConsentRequestForm.controls.project_id"
        [required]="true">
      </deal-search>
      <mat-form-field class="col-md-6" appearance="fill">
        <mat-label>Request Type</mat-label>
        <mat-select
          [formControl]="
            addConsentRequestForm.controls.consent_request_type_id
          ">
          @for (
            consentType of consentRequestsService.consentRequestTypes$
            | async
            ; track
            consentType) {
            <mat-option
              [value]="consentType">
              {{ consentType.request_type }}
            </mat-option>
          }
        </mat-select>
        <mat-error>Type is required!</mat-error>
      </mat-form-field>
    </div>
    <div class="row gutters">
      <mat-form-field class="col-12" appearance="fill">
        <mat-label>Request Details</mat-label>
        <textarea
          matInput
          style="resize: none"
          cdkTextareaAutosize
        [formControl]="addConsentRequestForm.controls.details"></textarea>
      </mat-form-field>
    </div>
    <div class="row gutters">
      <mat-form-field class="col-md-6">
        <mat-label>Received Date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [formControl]="addConsentRequestForm.controls.received_date" />
        <mat-datepicker-toggle matIconSuffix [for]="picker">
        </mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="col-md-6">
        <mat-label>Timing Date</mat-label>
        <input
          matInput
          [matDatepicker]="timingPicker"
          [formControl]="addConsentRequestForm.controls.timing_date" />
        <mat-datepicker-toggle matIconSuffix [for]="timingPicker">
        </mat-datepicker-toggle>
        <mat-datepicker #timingPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="row gutters">
      <div class="col-md-6">
        <mat-checkbox
          [formControl]="addConsentRequestForm.controls.is_urgent_flag">
          Urgent
        </mat-checkbox>
      </div>
      <mat-form-field class="col-md-6">
        <mat-label>Urgency Note</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          style="resize: none"
          [formControl]="
            addConsentRequestForm.controls.urgency_note
          "></textarea>
      </mat-form-field>
    </div>
    <div class="row gutters">
      <mat-form-field class="col-md-6">
        <mat-label>Request Status</mat-label>
        <mat-select
          [formControl]="addConsentRequestForm.controls.consent_status_id">
          @for (
            status of consentRequestsService.consentStatuses$ | async
            ; track
            status) {
            <mat-option
              [value]="status.id">
              {{ status.status }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <person-search
        roleColumn="asset_manager_id"
        roleName="Asset Manager"
        class="col-md-6"
        [control]="addConsentRequestForm.controls.asset_manager_id">
      </person-search>
    </div>
    <div class="row gutters">
      <person-search
        class="col-md-6"
        roleName="Underwriter"
        roleColumn="underwriter_id"
        [control]="addConsentRequestForm.controls.underwriter_id">
      </person-search>
      <person-search
        class="col-md-6"
        roleName="Fund Manager"
        roleColumn="fund_manager_id"
        [control]="addConsentRequestForm.controls.fund_manager_id">
      </person-search>
    </div>
    <div class="row gutters">
      <person-search
        roleColumn="consent_manager_id"
        roleName="Consent Manager"
        class="col-md-6"
        [control]="addConsentRequestForm.controls.consent_manager_id">
      </person-search>
      <person-search
        roleColumn="investor_relations_id"
        roleName="Investor Relations"
        class="col-md-6"
        [control]="addConsentRequestForm.controls.investor_relations_id">
      </person-search>
    </div>
    <div class="row gutters">
      <person-search
        class="col-md-6"
        roleName="Disposition Associate"
        roleColumn="disposition_associate_id"
        [control]="addConsentRequestForm.controls.disposition_associate_id">
      </person-search>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close({ created: false })">
    Cancel
  </button>
  <button
    mat-raised-button
    [disabled]="!addConsentRequestForm.valid"
    (click)="saveRequest()"
    color="primary">
    Save
  </button>
</div>
